import styled from 'styled-components';
import { breakpoints } from '../../shared/utils/Styles';

export const StyledIcon = styled.i`
  font-size: ${(props) => `${props.size || 1}em`};
  ${(props) => props.iconOnly && 'padding-right: 0px'};

  @media (min-width: ${breakpoints.tablet}) {
  }
  @media (min-width: ${breakpoints.small}) {
  }
  @media (min-width: ${breakpoints.large}) {
  }
`;
